import { useEffect, useState } from "react";
import { api, fmtR } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Ticket, CheckCircle2, Clock, Ban, Wallet, TrendingUp, ScanLine, Layers } from "lucide-react";

const Kpi = ({ label, value, icon: Icon, tone = "espresso", testid }) => (
    <Card className="border-[#E5E0D8] shadow-none rounded-sm" data-testid={testid}>
        <CardContent className="p-5">
            <div className="flex items-start justify-between">
                <div className="text-xs tracking-widest text-[#7A726D] uppercase">{label}</div>
                <Icon className={`w-4 h-4 text-${tone}`} strokeWidth={1.5} />
            </div>
            <div className="font-display text-3xl font-bold text-espresso mt-3 tracking-tight">{value}</div>
        </CardContent>
    </Card>
);

export default function Dashboard() {
    const [s, setS] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/reports/summary").then((r) => setS(r.data)).finally(() => setLoading(false));
    }, []);

    return (
        <div className="p-8 max-w-7xl" data-testid="dashboard-page">
            <div className="mb-8">
                <div className="text-xs tracking-widest text-[#7A726D] uppercase">Overview</div>
                <h1 className="font-display text-4xl font-bold text-espresso tracking-tight">Voucher control room</h1>
                <p className="text-sm text-[#7A726D] mt-1">Real-time view across all outlets.</p>
            </div>

            {loading ? (
                <div className="text-[#7A726D] animate-pulse">Loading…</div>
            ) : (
                <>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                        <Kpi label="Issued" value={s.total_issued} icon={Ticket} testid="kpi-issued" />
                        <Kpi label="Active" value={s.active} icon={CheckCircle2} testid="kpi-active" />
                        <Kpi label="Redeemed" value={s.redeemed} icon={ScanLine} testid="kpi-redeemed" />
                        <Kpi label="Expired" value={s.expired} icon={Clock} testid="kpi-expired" />
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <Kpi label="Void" value={s.void} icon={Ban} testid="kpi-void" />
                        <Kpi label="Outstanding (R)" value={fmtR(s.outstanding_liability)} icon={Wallet} testid="kpi-outstanding" />
                        <Kpi label="Redeemed Value" value={fmtR(s.total_redeemed_value)} icon={TrendingUp} testid="kpi-redeemed-value" />
                        <Kpi label="Redemptions" value={s.redemptions_count} icon={Layers} testid="kpi-redemptions" />
                    </div>
                </>
            )}
        </div>
    );
}
